export const CREATE_GB_SUBMISSION_REQUEST = 'CREATE_GB_SUBMISSION_REQUEST';
export const CREATE_GB_SUBMISSION_SUCCESS = 'CREATE_GB_SUBMISSION_SUCCESS';
export const CREATE_GB_SUBMISSION_FAILURE = 'CREATE_GB_SUBMISSION_FAILURE';

export const CREATE_DE_SUBMISSION_REQUEST = 'CREATE_DE_SUBMISSION_REQUEST';
export const CREATE_DE_SUBMISSION_SUCCESS = 'CREATE_DE_SUBMISSION_SUCCESS';
export const CREATE_DE_SUBMISSION_FAILURE = 'CREATE_DE_SUBMISSION_FAILURE';
